import FundDetailsTabRow from 'components/Pages/FundsCenter/FundDetails/FundDetailsTabRow';
import { useI18n } from 'next-localization';
import { useFetchLiteratureTabDataQuery } from '@/store/fundDetails/services/fundDetailsApi';
import FundDetailsTabSkeleton from 'components/Pages/FundsCenter/FundDetails/FundDetailsTabSkeleton';
import AlertMessageBase from 'components/Generic/AlertMessageBase';
import useHelpers from 'hooks/helpers';
import FundDetailsSecondLevelTabGroup from 'components/Pages/FundsCenter/FundDetails/FundDetailsSecondLevelTabGroup';
import { useMemo } from 'react';
import LiteratureSharedTab from 'components/Pages/FundsCenter/FundDetails/SecondLevelTabs/LiteratureSharedTab';
import usePayload from 'hooks/useFundDetailsRequestPayload';

type Props = {
  title: string;
};

type AvailableTabs = {
  [key: string]: boolean;
};

const FundDetailsLiteratureTab = ({ title }: Props) => {
  const { t } = useI18n();
  const { isExperienceEditor, getErrorDictionary } = useHelpers();

  const payload = usePayload();
  const { data, error, isLoading } = useFetchLiteratureTabDataQuery(payload, {
    skip: isExperienceEditor,
  });

  const availableTabs: AvailableTabs = useMemo(() => {
    return data?.content.reduce((tabs, tab) => {
      tabs[t(tab.title)] = true;
      return tabs;
    }, {});
  }, [data, t]);

  const tabComponentsByTabName = {
    [t('fundDetailsLiteratureFundLiterature')]: LiteratureSharedTab,
    [t('fundDetailsLiteratureSustainability')]: LiteratureSharedTab,
    [t('fundDetailsLiteratureAnnouncements')]: LiteratureSharedTab,
    [t('fundDetailsLiteratureSectionNineteen')]: LiteratureSharedTab,
    [t('fundDetailsLiteratureTaxInformation')]: LiteratureSharedTab,
  };

  const tabTitlesByTabName: Record<string, string> = {
    [t('fundDetailsLiteratureFundLiterature')]: t('fundDetailsLiteratureFundLiterature'),
    [t('fundDetailsLiteratureSustainability')]: t('fundDetailsLiteratureSustainability'),
    [t('fundDetailsLiteratureAnnouncements')]: t('fundDetailsLiteratureAnnouncements'),
    [t('fundDetailsLiteratureSectionNineteen')]: t('fundDetailsLiteratureSectionNineteen'),
    [t('fundDetailsLiteratureTaxInformation')]: t('fundDetailsLiteratureTaxInformation'),
  };

  const LiteratureContent = () => {
    if (isLoading || error) {
      return isLoading ? (
        <FundDetailsTabSkeleton />
      ) : (
        <AlertMessageBase type="error" title={t(getErrorDictionary(error))} />
      );
    } else if (data?.content && data?.content.length !== 0) {
      return data.content.length > 1 ? (
        <FundDetailsSecondLevelTabGroup
          availableTabs={availableTabs}
          tabComponentsByTabKeys={tabComponentsByTabName}
          tabTitlesByTabKeys={tabTitlesByTabName}
          tabData={data.content}
        />
      ) : (
        <LiteratureSharedTab tabData={data.content} />
      );
    } else {
      return (
        <FundDetailsTabRow>
          <div className="body-default">{t('noResultsMessage')}</div>
        </FundDetailsTabRow>
      );
    }
  };
  return (
    <section className="default-section-padding background-white">
      <FundDetailsTabRow fullWidth>
        <h2>{title}</h2>
      </FundDetailsTabRow>

      <div className="mt-5">
        <LiteratureContent />
      </div>
    </section>
  );
};

export default FundDetailsLiteratureTab;
